import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect } from 'react';
import './justificarMinutaGrilla.scss';
import { CustomButton } from '../../../components/customButton/CustomButton';

import toast from 'react-hot-toast';
import { JUSTIFICAR_MASIVA } from '../../../data/graphQL/mutations/GenerarMinuta/justificaMasiva';
import { adaptMinutaPeriodoActivo, GET_MINUTA_PERIODO_ACTIVO } from '../../../data/graphQL/queries/GenerarMinuta/getPeriodoMinutaActivo';
import moment from 'moment';

export const JustificarMinutaGrillaHeader = ({
  allowedWrite,
  justificacionesGrilla,
  justificacionesSeleccionadas,
  filters,
  setJustificacionesSeleccionadas,
  setRefetchGrilla,
  setGenerateRunning,
  periodoActivo,
  setPeriodoActivo
}) => {
  const descMes = ["", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  const [getPeriodoActivo, { data: periodoData, loading: periodoLoading }] = useLazyQuery(GET_MINUTA_PERIODO_ACTIVO, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!periodoData) return;
    setPeriodoActivo(periodoData.periodoMinutaActivo != null ? adaptMinutaPeriodoActivo(periodoData.periodoMinutaActivo) : null);
	}, [periodoData]);

  useEffect(() => {
    if (!periodoLoading)
    getPeriodoActivo();
  }, []);

  const [createMinutaMasiva, { loading: createMinutaMasivaLoading }] = useMutation(JUSTIFICAR_MASIVA, {
    onCompleted: (data) => {
      setGenerateRunning(false);
      if (data.justificarMasiva.success) {
        toast.success(data.justificarMasiva.valorEsperado);
        // recargo la grilla
        setRefetchGrilla(true);
        setJustificacionesSeleccionadas([]);
      } else {
        toast.error(data.justificarMasiva.valorEsperado);
      }
    }
  });

  const generateInput = () => {
    let lista = [];
    justificacionesSeleccionadas.map((justificacion) => {
      lista.push({
        idPendiente: justificacion.idPendiente,
        idEvaluacion: justificacion.idEvaluacion,
        idPaciente: justificacion.idPaciente,
        idPlanCuidado: justificacion.idPlanCuidado,
        codSAPPaciente: justificacion.codPacienteSAP,
        codSAPCliente: justificacion.codClienteSAP,
        codSAPPlan: justificacion.codPlanSAP,
        precioDiario: justificacion.precioDiario,
        precioSAP: justificacion.precioSAP
      });
    });
    return {
      input: lista,
      idDelegacion: filters.idDelegacion
    };
  };

  const handleGenerar = () => {
    if (justificacionesSeleccionadas.length > 0) {
      const input = generateInput();
      setGenerateRunning(true);
      createMinutaMasiva({ variables: input });
    } else {
      toast.error("Debe seleccionar al menos un registro para generar minutas.");
    }
  };

  return (
    <>
        <div className='top-buttons'>       
            <div className='chip-periodo'>
                {
          periodoActivo == null ?
          <strong>- No existe período activo</strong> :
          <strong>{descMes[periodoActivo?.mes]} {periodoActivo?.anio} ({periodoActivo?.fechaDesde != "" ?
            moment(periodoActivo?.fechaDesde).format("DD/MM/YYYY") : ""} - {periodoActivo?.fechaHasta != "" ? moment(periodoActivo?.fechaHasta).format("DD/MM/YYYY") :

            ""})
                        </strong>
          }
            </div>     
            <CustomButton
          isLoading={createMinutaMasivaLoading}
          disabled={
          !allowedWrite ||
          justificacionesGrilla == null || justificacionesGrilla.length == 0 ||
          justificacionesSeleccionadas.length == 0
          }
          onClick={handleGenerar}>
          
                Generar Minuta
            </CustomButton>
        </div>
        </>);

};